<!--
 * @Date: 2022-09-26 14:44:00
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-12 19:04:51
 * @description: description
 * 价值观页面
-->
<template>
  <div :class="$style.senseOfWorth">
    <div :class="$style.title">{{ info.title }}</div>
    <div :class="$style.blockBg" />
    <div :class="$style.contentBox">
      <div
        :class="$style.contentItem"
        v-for="(item, index) in info.content"
        :key="index"
        @mouseenter="onMouseEnter(index)"
        @mouseleave="onMouseLeave"
      >
        <img :src="item.cover" alt="" />
        <div :class="$style.contentLabel">{{ item.label }}</div>
        <div :class="{[$style.contentItemOn]: cur == index }" ></div>
      </div>
    </div>
    <div :class="$style.contentLine" />
    <div :class="$style.valueBox">
      <div :class="$style.infoBox">
        <div :class="$style.cover" v-if="showCover"></div>
        <div :class="$style.valueTitle">
          {{ info.content[cur].label }}
        </div>
        <div :class="$style.valueContent">
          {{ info.content[cur].info }}
        </div>
      </div>
    </div>
    <div :class="$style.valueLine" />
  </div>
</template>
<script>

export default {
  name: 'aboutus-sense-of-worth',
  props: {
    info: Object
  },
  data () {
    return {
      cur: 0,
      timer: null,
      showCover: false
    }
  },
  methods: {
    onMouseEnter (index) {
      this.timer = setTimeout(() => {
        this.cur = index
        this.showCover = true
        setTimeout(() => {
          this.showCover = false
        }, 200)
      }, 100)
    },
    onMouseLeave () {
      clearTimeout(this.timer)
      this.timer = null
      this.showCover = false
    }
  }
}
</script>

<style lang="scss" module>
.senseOfWorth {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;

  .title {
    height: 45px;
    margin-bottom: 41px;
    text-align: center;
    line-height: 45px;
    font-size: 32px;
    font-weight: 600;
    color: #333333;
  }

  .blockBg {
    position: absolute; top: 247px; right: -117px; z-index: 9;
    width: 208px;
    height: 160px;
    background: no-repeat
      url("../../../assets/img/aboutus/pc/sense.of.worth/block-bg.png") center
      top / cover;
  }

  .contentBox {
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: center;
    margin-bottom: 52px;
  }

  .contentItem {
    box-sizing: border-box;
    position: relative;
    width: 260px;
    height: 240px;
    padding: 50px 77px 47px;
    margin-right: 50px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 16px;
    text-align: center;
    cursor: pointer;

    &:last-child{
      margin-right: 0;
    }
  }

  .contentItemOn {
    position: absolute; left: 0; right: 0; bottom: -53px;
    width: 27px;
    height: 16px;
    margin: 0 auto;
    background: no-repeat
      url("../../../assets/img/aboutus/pc/sense.of.worth/line-triangle.png") center
      top / cover;
    background-size: 100% 100%;
  }

  .contentLabel {
    height: 33px;
    margin-top: 30px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 500;
    color: #333333;
  }

  .contentLine {
    width: 100%;
    height: 2px;
    background: #ffceae;
    margin-bottom: 13px;
  }
  //  价值观
  .valueBox {
    position: relative;
    height: 187px;
    padding: 38px 30px 0 284px;
    background-image: url("../../../assets/img/aboutus/pc/sense.of.worth/left-icon.png"),
      url("../../../assets/img/aboutus/pc/sense.of.worth/value-bg.png"),
      url("../../../assets/img/aboutus/pc/sense.of.worth/right-icon.png");
    background-repeat: no-repeat;
    background-position: left top 6px, left 30px top, right bottom 20px;
    background-size: 30px 25px, 214px 188px, 30px 25px;

    & .cover {
      position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 999;
      background: #fff;
      opacity: 0;
      animation: flash 0.2s ease-in;
    }
  }

  .valueTitle {
    height: 28px;
    margin-bottom: 16px;
    line-height: 28px;
    font-size: 24px;
    font-weight: 500;
    color: #404040;
  }

  .valueContent {
    height: 68px;
    line-height: 34px;
    font-size: 20px;
    font-weight: 400;
    color: #404040;
  }

  .valueLine {
    width: 100%;
    height: 2px;
    background: #ffceae;
  }

  .infoBox {
    position: relative;
  }
}

@keyframes flash {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
